module.exports = __webpack_public_path__ + "img/11_L3.6c5d24e4.svg";